import { useLang } from "../i18n/lang";

// Fotografía principal de una página de contenido (servicio, problema, guía o hub).
// Visible en el primer viewport: no usar loading="lazy".
export const PagePhoto = ({ photo, priority = true, className = "" }) => {
  const lang = useLang();
  if (!photo) return null;
  const alt = lang === "en" ? photo.altEn : photo.alt;
  return (
    <figure className={`rounded-sm overflow-hidden border hairline ${className}`} data-testid="page-photo">
      <img
        src={`${photo.src}-1600.webp`}
        srcSet={`${photo.src}-800.webp 800w, ${photo.src}-1600.webp 1600w`}
        sizes="(min-width: 1024px) 66vw, 100vw"
        width="1600"
        height="1000"
        alt={alt}
        loading={priority ? "eager" : "lazy"}
        decoding="async"
        className="w-full h-auto object-cover"
      />
    </figure>
  );
};
